import { useEffect } from 'react'
import { apiURL } from '../utilities/URLs'
import { company, customerData } from '../utilities/CustomerData'

export function IDMEVerification({ isSpouse, kycError, lienAmount, interestAmount, loanInterestAmount }) {
  const idMeURL = `${process.env.REACT_APP_IDME_API_DOMAIN}/oauth/authorize?client_id=${process.env.REACT_APP_IDME_CLIENT_ID}&redirect_uri=${apiURL}/idme&response_type=code&scope=openid%20http://idmanagement.gov/ns/assurance/ial/2/aal/2${isSpouse ? '&state=spouse' : ''}`

  useEffect(() => {
    document.title = `${company.companyName} | IDme Verification`
  }, [])

  const handleStartIDme = () => {
    if(!customerData.impersonationMode) {
      localStorage.setItem('idme', '0')
      if(isSpouse) {
        localStorage.setItem('idmeSpouse', '1')
        localStorage.setItem('advanceFundingInfo', JSON.stringify({
          lienAmount: lienAmount,
          interestAmount: interestAmount,
          loanInterestAmount: loanInterestAmount
        }))
      }
    }
    
    window.location.href = idMeURL
  }

  return (
    <div className='w-full h-[80dvh] flex flex-col items-center justify-center'>
      {isSpouse ? (
        <div className='max-w-lg max-sm:w-11/12 flex flex-col items-center justify-center shadow-lg rounded-md p-8 gap-4'>
          <p className='text-lg font-semibold text-center'>Spouse Identity Verification</p>
          <p className='text-center'>It looks like you and your spouse are both claiming this tax credit. We just need to confirm your spouse's information before we can proceed.</p>
          <div className='flex justify-center w-full'>
            <button onClick={handleStartIDme}>
              <img className='w-56 h-11' src='https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg' />
            </button>
          </div>
          <p className='italic text-sm text-gray-400'>NOTE: We will be using ALL personal information (including address) for future use. Please make sure your IDme information is completely up to date and is <span className='font-bold'>YOUR INFORMATION</span> and not someone elses, like a spouse.</p>
          {kycError && <p className='text-sm text-red-600'>{kycError}</p>}
        </div>
      ) : (
        <div className='max-w-lg max-sm:w-11/12 flex flex-col items-center justify-center shadow-lg rounded-md p-8 gap-4'>
          <p className='text-lg font-semibold text-center'>Identity Verification</p>
          <p className='text-center'>Before we begin, let's identify who you are.</p>
          <div className='flex justify-center w-full'>
            <button onClick={handleStartIDme}>
              <img className='w-56 h-11' src='https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg' />
            </button>
          </div>
          <p className='italic text-sm text-gray-400'>NOTE: We will be using ALL personal information (including address) for future use. Please make sure your IDme information is completely up to date and is <span className='font-bold'>YOUR INFORMATION</span> and not someone elses, like a spouse.</p>
          {kycError && <p className='text-sm text-red-600'>{kycError}</p>}
        </div>
      )}
    </div>
  )
}